import { render, staticRenderFns } from "./Signage2.vue?vue&type=template&id=1105c49d&scoped=true"
import script from "./Signage2.vue?vue&type=script&lang=js"
export * from "./Signage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1105c49d",
  null
  
)

export default component.exports